/*
* card kingdom site-wide notification
* This is a self contained closure, and has no public interface.
* The only public attribute is ck.sitewideCountdown, which is written in php template inline by server
* and handled here
 */

$(function () {
  let updateInterval = 3;

  let setCookie = function(cname, cvalue, exdays) {
    let expires = '', cookieString="";
    //if no exdays, expire with session
    if(typeof exdays === 'number')  {
      let d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000)); //set for specifed time
      expires = 'expires='+d.toUTCString();
    }
    document.cookie = (cname + '=' + cvalue + '; ' + expires +'; path=/');
  };

  let getCookie = function(cname) {
    let name = cname + '=';
    let ca = document.cookie.split(';');
    for(let i=0; i<ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1);
      if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
    }
    return "";
  };

  let displayCountdown = function (totalSeconds) {
    let countdown, untilDays, untilHours, untilMinutes, untilSeconds;
    untilSeconds = parseInt(totalSeconds);
    if (untilSeconds < 0) {
      countdown = 'ANY MOMENT';
    } else {
      countdown = 'in ';
      untilDays = Math.floor(untilSeconds / (3600 * 24));
      //dont display days unless there is more than a day
      if (untilDays === untilDays && untilDays > 0) {
        if (untilDays > 0) {
          countdown = untilDays + 'd ';
        }
        untilSeconds -= untilDays * 3600 * 24;
      }

      untilHours = Math.floor(untilSeconds / 3600);
      let hourDisplay = untilHours.toString();
      hourDisplay = hourDisplay.padStart(2, '0');
      countdown = countdown + hourDisplay + ':';
      untilSeconds -= untilHours * 3600;
      untilMinutes = Math.floor(untilSeconds / 60);
      let minutesDisplay = untilMinutes.toString();
      minutesDisplay = minutesDisplay.padStart(2,'0');
      countdown = countdown + minutesDisplay + ':';
      untilSeconds -= Math.floor(untilMinutes * 60)
      if(untilHours < 1) {
        let secondsDisplay = untilSeconds.toString();
        secondsDisplay = secondsDisplay.padStart(2,'0');
        countdown = countdown + secondsDisplay;
      } else {
        countdown = countdown + '00';
      }
    }
    $('#siteNotice .countdownTime').text(countdown);
    $('#siteNotice .ckClose').on('click', function () {
      $('#siteNotice').remove();
      $('body').removeClass('activeCountdown');
      $('#header').css('top','auto');
      // $('.mainWrapper').css({'top':'auto','padding-bottom':'0px'});
      //$('.shopMain .sidePanel').css('padding-top','0px');
      //$('#sidecartContainer.flashAlert,.submenu,#offcanvasNavbar').css('margin-top','0px');
      $(window).off('resize.with-notice');
      setCookie('hideSitewideMessage', 'true');
    });
  }

  let adjustForNotice = function(){
    let noticeHeight = $('#siteNotice').outerHeight() || 0;
    ck.noticeOffset = noticeHeight;
    $('#header').css('top',(noticeHeight + 'px'));
    //$('.mainWrapper').css({'top':(noticeHeight + 'px'),'padding-bottom':(noticeHeight + 'px')});
    //$('.shopMain .sidePanel').css('padding-top',(noticeHeight + 'px'));
    //$('#sidecartContainer,.flashAlert').css('margin-top',(noticeHeight + 'px'));
    if($(window).width() < 776)
    {
      $('#offcanvasNavbar,#header .submenu').css('margin-top',(noticeHeight + 'px'));
    }

  };
  //based on user preference in cookie, initiate display loop.
  //if less than an hour left, increment seconds and force show on pageload
  if (typeof ck.sitewideCountdown === 'number' && (getCookie('hideSitewideMessage') !== 'true' || ck.sitewideCountdown < 3600)) {
    if (ck.sitewideCountdown > -300) {  //display final warning up for 5 min after time expires
      $('#siteNotice').append('<span class="ckClose">X</span>');
      $('body').addClass('activeCountdown');
      displayCountdown(ck.sitewideCountdown);
      setInterval(function () {
        ck.sitewideCountdown -= updateInterval;
        displayCountdown(ck.sitewideCountdown);
      }, (updateInterval * 1000));

      $(window).on('resize.with-notice', function () {
        adjustForNotice();
      });
      adjustForNotice();
    }
  }

});
